enum FailedOrderReason {
  NOT_ALL_PRODUCTS_PREPARED,
  NOT_ALL_PRODUCTS_PROCESSED
}

export default FailedOrderReason
